import React from "react";
import CategoryFiltersComponent from "./CategoryFiltersComponent";
import CollectionFiltersComponent from "./CollectionFiltersComponent";
import LicenseFiltersComponent from "./LicenseFiltersComponent";

type FilterContentProps = {
  activeNavigation: any;
  setProductList?: any;
  productList?: any;
  handleChangeActiveFilters?: any;
  setActiveFilters?:any
  activeFilters?:any
};

const FilterContent: React.FC<FilterContentProps> = ({
  activeNavigation,
  setProductList,
  productList,
  // handleChangeActiveFilters,
  setActiveFilters,
  activeFilters,
}) => {
  if (!activeNavigation) return null;

  switch (activeNavigation.text) {
    case "Categories":
      return (
        <CategoryFiltersComponent
          setProductList={setProductList}
          productList={productList}
          // handleChangeActiveFilters={handleChangeActiveFilters}
          setActiveFilters={setActiveFilters}
          activeFilters={activeFilters}
        />
      );
    case "Collections":
      return (
        <CollectionFiltersComponent
          setProductList={setProductList}
          productList={productList}
          // handleChangeActiveFilters={handleChangeActiveFilters}
          setActiveFilters={setActiveFilters}
          activeFilters={activeFilters}
        />
      );
    case "License":
      return (
        <LicenseFiltersComponent
          setProductList={setProductList}
          productList={productList}
          // handleChangeActiveFilters={handleChangeActiveFilters}
          setActiveFilters={setActiveFilters}
          activeFilters={activeFilters}
        />
      );
    default:
      return null;
  }
};

export default FilterContent;
